module.exports = __webpack_public_path__ + "static/img/icon_error.87c07010.png";